'use client'

import { createLocalStorageHook } from '@/hooks/browser/createLocalStorageHook'
import { PropsWithChildren } from 'react'
import { z } from 'zod'
import { useHotkeys } from 'react-hotkeys-hook'

const DARK_MODE_KEY = 'dark-mode'

export const useDarkMode = createLocalStorageHook(DARK_MODE_KEY, z.boolean())

export function DarkModeProvider({ children }: PropsWithChildren) {
  const [darkmode, setDarkmode] = useDarkMode()
  useHotkeys('alt+l', (event) => {
    event.preventDefault()
    setDarkmode((prev) => !prev)
  })
  return (
    <html lang="en" className={darkmode ? 'dark' : undefined}>
      {children}
    </html>
  )
}
